<template>
    <div class="md-testimionial cropper" v-show="show">
        <div class="crop-shadow"></div>
        <section class="crop-dialog">
            <span
                data-method="close"
                class="iconfont icon-close"
                @click="cancel"
            ></span>
            <div class="main-container">
                <vue-cropper
                    v-if="initCropper"
                    ref="cropper"
                    :img="url"
                    :output-size="option.outputSize"
                    :output-type="option.outputType"
                    :info="true"
                    :full="option.full"
                    :fixed="fixed"
                    :fixed-number="fixedNumber"
                    :can-move="option.canMove"
                    :can-move-box="option.canMoveBox"
                    :fixed-box="option.fixedBox"
                    :original="option.original"
                    :auto-crop="option.autoCrop"
                    :auto-crop-width="option.autoCropWidth"
                    :auto-crop-height="option.autoCropHeight"
                    :center-box="option.centerBox"
                    :high="option.high"
                    mode="contain"
                    :max-img-size="option.max"
                />
            </div>
            <div class="btn-container">
                <span
                    @click="$refs.cropper.changeScale(-1)"
                    class="iconfont icon-zoomout"
                    :title="$t('md-testimonial.zoomOut')"
                ></span>
                <span
                    @click="$refs.cropper.changeScale(1)"
                    class="iconfont icon-zoomin"
                    :title="$t('md-testimonial.zoomIn')"
                ></span>
                <span
                    @click="$refs.cropper.rotateLeft()"
                    class="iconfont icon-rotate-left"
                    :title="$t('md-testimonial.rotateLeft')"
                ></span>
                <span
                    @click="$refs.cropper.rotateRight()"
                    class="iconfont icon-rotate-right"
                    :title="$t('md-testimonial.rotateRight')"
                ></span>
                <span class="finish-crop iconfont" @click="cropper">{{
                    $t('md-testimonial.ok')
                }}</span>
            </div>
        </section>
    </div>
</template>

<script>
import util from '../../../common/util';
import 'vue-cropper/dist/index.css'
import { defineAsyncComponent } from 'vue';

export default {
    emits: ['update:show', 'change'],
    name: 'CropImg',
    i18next: {
        ns: 'md-testimonial'
    },
    props: {
        show: {
            type: Boolean
        }
    },
    components: {
        VueCropper: defineAsyncComponent(() =>
            import(/* webpackChunkName: "vue-cropper"*/ 'vue-cropper').then(
                res => res.VueCropper
            ))
    },
    data: function() {
        return {
            option: {
                //  Generate image quality
                outputSize: 1,
                autoCrop: true,
                fixedBox: false,
                fixedNumber: [1, 1],
                size: 1,
                outputType: 'png',
                full: false,
                original: false,
                autoCropWidth: 750,
                autoCropHeight: 340,
                centerBox: true,
                high: true,
                max: 9999
            },
            fixed: false,
            url: '',
            imageWidth: 0,
            imageHeight: 0,
            initCropper: false
        };
    },
    mounted() {
        this.initCropper = true;
    },
    methods: {
        cancel() {
            this.option.fixedNumber = [1, 1];
            this.url = '';
            this.imageWidth = 0;
            this.imageHeight = 0;
            this.$emit('update:show', false);
        },
        changeImage(e) {
            var file = e.target.files[0];
            if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                this.$message.warning(
                    this.$t('md-testimonial.theImageTypeMustBe')
                );
                return false;
            }

            var reader = new FileReader();

            reader.onload = async e => {
                let data;
                if (typeof e.target.result === 'object') {
                    //  Bundle Array Buffer Converted to blob  in the case of base64 unnecessary
                    data = window.URL.createObjectURL(
                        new Blob([e.target.result])
                    );
                } else {
                    data = e.target.result;
                }
                let ratio = await this.getImageRatio(e.target.result);
                //  Adjust the aspect ratio of the screenshot to be consistent with the image ratio
                this.option.fixedNumber = ratio;
                this.imageWidth =
                    this.option.fixedNumber[1] / this.option.fixedNumber[0] > 1
                        ? this.option.fixedNumber[0]
                        : (150 / this.option.fixedNumber[1]) *
                          this.option.fixedNumber[0];
                this.imageHeight =
                    this.option.fixedNumber[1] / this.option.fixedNumber[0] > 1
                        ? this.option.fixedNumber[1]
                        : 150;

                this.url = data;
                this.$emit('update:show', true);
            };
            //  Converted to base64
            reader.readAsDataURL(file);
        },
        getImageRatio(url) {
            return new Promise((resolve, reject) => {
                let img = new Image();
                img.onload = function() {
                    resolve([img.width, img.height]);
                };
                img.onerror = function() {
                    reject();
                };

                img.src = url;
            });
        },
        cropper() {
            this.$refs.cropper.getCropData(data => {
                util.UploadImage(data)
                    .then((url) => {
                        this.url = url;
                        this.$emit('change', this.url);
                        this.cancel();
                    })
                    .catch(msg => {
                        util.toast(msg);
                    });
            });
        }
    }
};
</script>
<style lang="scss">
@import '~@/theme/media.scss';
.md-testimionial.cropper {
    .crop-shadow {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
    }
    .crop-dialog {
        width: 820px;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        overflow: hidden;
        background-color: #ffffff;
        border-radius: 4px;
        padding: 60px 60px 98px 60px;
        z-index: 100;

        .main-container {
            height: 300px;
            overflow: hidden;
        }

        img.slice {
            max-width: 100%;
            vertical-align: middle;
        }

        .icon-close {
            position: absolute;
            padding: 5px;
            right: 17px;
            top: 17px;
            z-index: 2;
            cursor: pointer;
            font-size: 22px;
            color: #4d4d4d;
        }

        .btn-container {
            position: absolute;
            left: 50%;
            bottom: 30px;
            transform: translate(-50%, 0);
            height: 40px;
            display: flex;
            align-items: center;
            cursor: default;
            white-space: nowrap;

            .iconfont {
                display: inline-block;
                width: 36px;
                height: 36px;
                margin: 0 7px;
                opacity: 1;
                font-size: 14px;
                line-height: 36px;
                cursor: pointer;
                background: #000;
                color: white;
                border-radius: 50%;
                text-align: center;
                font-weight: 400;

                &:hover {
                    opacity: 0.6;
                }
            }

            .finish-crop {
                margin-left: 17px;
                display: block;
                width: 101px;
                height: 39px;
                border-radius: 20px;
                text-align: center;
                color: #ffffff;
                font-size: 15px;
                line-height: 39px;
                background-color: #f2aa18;
            }
        }
    }
}

@include media-600 {
    .md-testimionial {
        .crop-dialog {
            width: 360px;
            padding: 50px 30px 80px 30px;

            .icon-close {
                top: 6px;
                right: 6px;

                &::before {
                    font-size: 20px;
                }
            }

            .btn-container {
                bottom: 20px;

                span {
                    font-size: 30px;

                    &:hover {
                        opacity: 1;
                    }
                }

                .finish-crop {
                    height: 30px;
                    line-height: 30px;
                }
            }
        }
    }
}
</style>
